<div class="container" fxLayout="column" fxLayoutGap="10px">

    <div fxFlex>
        <div>
            <h3 style="text-align: center;font-weight: 600;font-size: 160%;">About Us</h3>
            <hr>
        </div>
    </div>
    <div fxFlex>
        <div fxLayout="column" fxLayout.gt-sm="row">
            <div fxFlex="80">
                <h2>Our History</h2>
                <p>Started in 2010, Red Sands Restaurant quickly established itself as a culinary icon par excellence in Chennai India. With its unique brand of world fusion cuisine that can be found nowhere else, it enjoys patronage from the A-list clientele
                    in India. Featuring four of the best three-star Michelin chefs in the world, you never know what will arrive on your plate the next time you visit us.</p>
                <p>The restaurant traces its humble beginnings to The Frying Pan, a successful chain started by our CEO, Mr. Pranjay Poddar, that featured for the first time the world's best cuisines in a pan.</p>
            </div>
            <div fxFlex="20">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title>
                            <h2>Facts At a Glance</h2>
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <dl>
                            <dt>Started</dt>
                            <dd>3 Feb. 2013</dd>
                            <dt>Major Stake Holder</dt>
                            <dd>Fine Foods Inc.</dd>
                            <dt>Last Year's Turnover</dt>
                            <dd>1,250,375 Rs.</dd>
                            <dt>Employees</dt>
                            <dd>40</dd>
                        </dl>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
    <div fxFlex>
        <mat-card>
            <blockquote>
                <h3>You better cut the pizza in four pieces because I'm not hungry enough to eat six.</h3>
                <footer>-- Yogi Berra,
                    <cite>The Wit and Wisdom of Yogi Berra,
            P. Pepe, Diversion Books, 2014</cite>
                </footer>
            </blockquote>
        </mat-card>
    </div>

    <h2 style="font-weight: 700;">Corporate Leadership</h2>
    <div *ngIf="leaders">
        <div *ngFor="let leader of leaders" [@expand]>
            <div class="leader">
                <div>
                    <img src="{{BaseURL + leader.image}}" height="50px" width="50px" style="border-radius: 50%">
                </div>
                <div fxFlex="95" fxFlexOffset="10px">
                    <span>{{leader.name}}</span> <span style="font-weight: bold;"> {{leader.abbr}}</span><br>
                    <span>{{leader.designation}}</span><br>
                    <span>{{leader.description}}</span>
                </div>
            </div>
        </div>
    </div>
    <div [hidden]="leaders || leaderErrMess">
        <mat-spinner mode="indeterminate"></mat-spinner>
        <h4>Loading . . . Please Wait</h4>
    </div>
    <div fxFlex *ngIf="leaderErrMess" [@expand]>
        <h2 style="text-align: center;">Error</h2>
        <h4>{{leaderErrMess}}</h4>
    </div>